import { ApplicationRef, ComponentFactoryResolver, DoBootstrap, DOCUMENT, Inject, NgModule, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';

import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { PasswordResetModule } from 'Angular/features/components/password-controls/password-reset/password-reset.module';
import { PasswordRevealModule } from 'Angular/features/components/password-controls/password-reveal/password-reveal.module';
import { PasskeyLoginModule } from 'PasskeysApp/features/passkey-login/passkey-login.module';

import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { PasswordResetComponent } from 'Angular/features/components/password-controls/password-reset/password-reset.component';
import { PasswordRevealComponent } from 'Angular/features/components/password-controls/password-reveal/password-reveal.component';
import { PasskeyLoginComponent } from 'PasskeysApp/features/passkey-login/passkey-login.component';
import { PasskeyLoginErrorComponent } from 'PasskeysApp/features/passkey-login/passkey-login-error.component';

import { getLogger } from 'Angular/state/logger';

@NgModule({
    imports: [
        BrowserModule,
        ConfigModule,
        NavigationModule,
        PasswordRevealModule,
        PasswordResetModule,
        PasskeyLoginModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
    ],
})
export class LoginModule implements DoBootstrap {
    /*
     * DoBootstrap enables manual bootstrapping for the selected bootstrap components
     * instead of using the bootstrap array.
     * This enables a template to have different entry components without hiding them.
     */
    static bootstrapComponents: Type<{}>[] = [
        PasswordRevealComponent,
        PasswordResetComponent,
        PasskeyLoginComponent,
        PasskeyLoginErrorComponent,
        TopBarNavComponent,
    ];

    constructor(@Inject(DOCUMENT) private _document: any, private componentFactoryResolver: ComponentFactoryResolver) {}

    ngDoBootstrap(applicationRef: ApplicationRef): void {
        LoginModule.bootstrapComponents.forEach((component) => {
            const { selector } = this.componentFactoryResolver.resolveComponentFactory(component);

            if (this._document.querySelector(selector)) {
                applicationRef.bootstrap(component);
            }
        });
    }
}
